module.exports = __webpack_public_path__ + "img/scale.00530aaa.png";